import React from "react";
import { Alert } from "@mui/material";

const ErrorDisplay = ({ error }) => {
  if (!error) return null;
  return (
    <Alert
      severity="error"
      sx={{
        marginTop: 2,
        textAlign: "center", // Center-align the error
      }}
    >
      {error}
    </Alert>
  );
};

export default ErrorDisplay;
